export default __webpack_public_path__ + "static/media/tacsfon-logo.7313eea4.png";